export const openInNewTab = (url: string) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}

export const getTabName = (title) => {
  return `m-note${title ? ` - ${title.toLowerCase()}` : ''}`
}
